import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
import { localizedFormatDate } from 'shared/domains/common-utils';
import { ErrorMessage } from 'shared/domains/forms/components/ErrorMessage';
import { localeConfig } from 'shared/domains/languages/config';
import { safeCalendarDate } from '../../utils/safeCalendarDate';
import { LinkField } from '../LinkField';
import { Container } from './styled';
export function DueDateField() {
    const localeCode = localeConfig.getActiveLocale().code;
    const [open, setOpen] = useState(false);
    const name = 'dueDate';
    const [dueDateField, , helpers] = useField(name);
    const TODAYS_DATE = new Date();
    const formatted = localizedFormatDate(dueDateField.value, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
    const toggleMenu = () => setOpen(!open);
    const closeMenu = () => setOpen(false);
    const handleOnChange = (date) => {
        const isoDate = date.toISOString();
        helpers.setValue(isoDate);
    };
    const handleRemoveDueDate = () => {
        helpers.setValue('');
    };
    return (<Container>
      <Menu.Root open={open} onClose={closeMenu} target={<LinkField name={name} icon={<Falcon icon="calendar"/>} linkText={formatted ||
                t({
                    message: 'Add due date',
                    comment: 'task due date field link text when no due date selected',
                })} linkPrefix={t({
                message: 'Due on',
                comment: 'task due date field link text when due date selected',
            })} onRemove={handleRemoveDueDate} onClick={toggleMenu}/>}>
        <Menu.Calendar locale={localeCode} value={safeCalendarDate(dueDateField.value)} min={TODAYS_DATE} onChange={handleOnChange}/>
      </Menu.Root>
      <ErrorMessage name="dueDate"/>
    </Container>);
}
